"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var mobx_react_lite_1 = require("mobx-react-lite");

var model_1 = require("./model");

var flowContainerComponentStart = {
  Wrapper: fclasses_1.Div,
  ComponentWrapper: fclasses_1.Div
};
var NodeProvider = core_1.withNode(react_1.default.Fragment);

var StaticFlowContainer = function StaticFlowContainer(_a) {
  var components = _a.components;
  var items = model_1.useItemHandlers().getItems();
  var Wrapper = components.Wrapper,
      ComponentWrapper = components.ComponentWrapper;
  return (// When in a static mode we don't want to use `bl-*` prefixed classes.
    react_1.default.createElement(Wrapper, null, items.map(function (flowContainerItem) {
      var ChildComponent = components[flowContainerItem.type]; // TODO: Inhance this notification when the data is bad

      if (!ChildComponent) {
        throw new Error(flowContainerItem.type + " is not an allowed content type");
      }

      return react_1.default.createElement(NodeProvider, {
        nodeKey: flowContainerItem.uuid,
        key: "flex-" + flowContainerItem.uuid
      }, react_1.default.createElement(ComponentWrapper, {
        className: flowContainerItem.wrapperProps && flowContainerItem.wrapperProps.className || ''
      }, react_1.default.createElement(ChildComponent, null)));
    }).filter(Boolean))
  );
};

StaticFlowContainer.displayName = 'FlowContainer';
var asStaticFlowContainer = lodash_1.flow(mobx_react_lite_1.observer, fclasses_1.designable(flowContainerComponentStart, 'FlowContainer'));
exports.default = asStaticFlowContainer(StaticFlowContainer);